<template>
<div class="page">
    <el-form :model="form" ref="form" :rules="rules" label-width="120px">
        <el-form-item label="用户名:" prop="userName">
            <el-input v-model="form.userName" auto-complete="off" placeholder="请输入用户号"></el-input>
        </el-form-item>
        <el-form-item label="登录名:" prop="loginName">
            <el-input v-model="form.loginName " auto-complete="off" placeholder="请输入登录名"></el-input>
        </el-form-item>
        <el-form-item label="用户密码:" prop="loginPwd">
            <el-input v-model="form.loginPwd" auto-complete="off" placeholder="请输入用户密码"></el-input>
        </el-form-item>
        <el-form-item label="邮箱地址:" prop="mailAdd">
            <el-input v-model="form.mailAdd" auto-complete="off" placeholder="请输入邮箱地址"></el-input>
        </el-form-item>
        <el-form-item label="手机号:" prop="mobileNo">
            <el-input v-model="form.mobileNo" auto-complete="off" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="状态:" prop="state">
            <el-select v-model='form.state' placeholder="选择用户状态">
                <el-option v-for='item in statusList' :key='item.label' :label='item.label' :value='item.value'></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="用户角色:" >
            <el-select v-model="form.roleId" placeholder="请选择用户角色" >
                <el-option v-for="item in allRole" :key="item.label" :label="item.label" :value="item.value"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="机构:" prop="orgId">
            <el-select v-model="form.orgId" placeholder="请选择机构" >
                <el-option v-for="item in allOrg" :key="item.orgName" :label="item.orgName" :value="item.orgId"></el-option>
            </el-select>
        </el-form-item>
        <el-row class="dialogButton">
            <el-col :span="12">
                <el-button type="info" @click="close" style="float:right">取 消</el-button>
            </el-col>
            <el-col :span="12">
                <el-button type="primary" @click="submit" :loading="submitLoading">确 定</el-button>
            </el-col>
        </el-row>
    </el-form>
</div>
</template>

<script>
export default {
    data() {
        return {
            form: {roleIds:[]},
            controlName:'add',
            statusList:[
              {label:'停用',value:'0'},
              {label:'起用',value:'1'}
          ],
            rules: {
                userName: [{
                        trigger: "blur",
                        required: true,
                        message: '请输入帐号'
                    },
                    {
                        trigger: 'blur',
                        max: 36,
                        message: '长度不得超过36个字符'
                    },
                    {
                        whitespace: true,
                        message: '不能包含空格'
                    },
                    {
                        trigger: "blur,change",
                        validator: (rule, value, callback) => {
                            if (value.match("^[0-9a-zA-Z]+$")) return callback()
                            return callback('只能是字母或数字')
                        }
                    }
                ],
                loginPwd: [{
                        trigger: "blur",
                        required: true,
                        message: '请输入密码'
                    },
                    {
                        trigger: 'blur',
                        max: 32,
                        message: '长度不得超过32个字符'
                    },
                    {
                        whitespace: true,
                        message: '不能包含空格'
                    }
                ],
                roleId: [{
                    trigger: 'change',
                    required: true,
                    message: '请选择一个用户角色'
                }],
                loginName: [
                    {trigger: 'blur',max: 32,required: true,message: '请输入登录名'}
                ],
                state: [{
                    trigger: 'change',
                    required: true,
                    message: '请选择用户状态'
                }],
            },
            submitLoading: false,
            allRole: [],
            allOrg:[]
        }
    },
    props:{
        close: {default: null},
        params: {default: Object}
    },
    watch:{
        params:{
            handler(newVal,old){
                if(newVal.userName){
                    this.form = {...{roleIds:[]},...newVal}
                    this.controlName = 'modify'
                }else this.form ={roleIds:[]},this.controlName = 'add'
                
            },
            deep: true
        }
    },
    components: {

    },
    methods: {
        async submit() {
            if(!await this.$check(this.$refs['form'].validate)) return
            this.submitLoading = true
            let ids = this.form.roleIds.toString()
            this.form.roleIds = ids
            console.log(this.form)
            const rsp = await this.$http.addUser(this.form)
            this.submitLoading = false
            if(rsp.code != 200) return 
            this.$message({message:'新增用户成功！',type:'success'})
            this.close()
        },
        //获取角色
        async getUser(){
            const rsp = await this.$http.getAllRole()
           if(rsp.code != 200) return
           this.allRole = rsp.data.records.reduce((prev,next,index,arr)=>{
               return prev.concat({
                   label: next.roleName,
                   value: next.roleId
               })
           },[])
           console.log(this.allRole)
        },
        async queryOrg(){
            let params = {
                includeUnuse: true
            }
            const rsp = await this.$http.getOrgS(params)
            if(rsp.code != 200) return
            this.allOrg = rsp.data.records
        },
    },
    created(){
        this.getUser()
        this.queryOrg()
        this.form = {...this.form,...this.params}
        if(this.form.userName) return this.controlName = 'modify'  
    }
}
</script>

<style scoped lang='scss'>
.dialogButton{
    /deep/ .el-button{margin: 0 25px;}
}
</style>
